import React, {useContext} from 'react';
import NodeHandles from './NodeHandles';
import {lessonEditorText} from '../lessonEditorText';
import {editorAddGradableBranch} from '../../../assets/images';
import {NodeData} from '../models';
import {EditorContext} from '../container/LessonEditorContainer';

interface Props {
  data: NodeData;
}

const ChallengeBranchHeaderNode = React.memo(({data}: Props) => {
  const context = useContext(EditorContext);

  const onClick = (e: any) => {
    context.setSelectedNode(data.payload, data.type);
    e.stopPropagation();
  };

  return (
    <div className="EditorChallengeNodeContainer" onClick={onClick}>
      <NodeHandles>
        <div
          className={`ChoiceHeader ${
            context.selectedNode?.internalId === data.payload.internalId
              ? 'ChoiceHeaderSelected'
              : ''
          }`}>
          <img src={editorAddGradableBranch} />
          <span>{lessonEditorText.challangeBranchHeaderText}</span>
        </div>
      </NodeHandles>
    </div>
  );
});

export default ChallengeBranchHeaderNode;
